import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd';

@Component({
  selector: 'app-export-type',
  templateUrl: './export-type.component.html',
  styleUrls: ['./export-type.component.less']
})
export class ExportTypeComponent implements OnInit {

  @Input() title: string;
  @Input() onExport = (type: 'excel' | 'pdf' | 'word') => { }
  constructor(private modal: NzModalRef) { }

  ngOnInit(): void {
  }

  closeModal(type: 'excel' | 'pdf' | 'word' | null) {
    if (type != null)
      this.onExport(type);
    this.modal.close();
  }
}
